/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RescheduleAction/view.blocks to change it.
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaPendingTag from 'DesignSystem/TysiaPendingTag/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RescheduleAction({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/AppointmentsList/Content/Appointment/EditAction/Content/Content/RescheduleAction"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="RescheduleAction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 disabled={true}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 weight="regular"
 text="Edit/Reschedule appointment"
/>
)}
</TysiaButton>
<TysiaPendingTag
  viewPath={`${viewPath}/TysiaPendingTag`}
/>
</div>
{children}
</React.Fragment>)
}